import * as React from "react";

import { Entry } from "../models/entries";

export function ScoreDisplay({
  entry,
  scoreOverride,
}: {
  entry: Entry;
  scoreOverride?: number;
}): JSX.Element {
  const score = scoreOverride ?? entry.overall_score;
  const scoreText = !entry.hidden
    ? score
      ? score.toFixed(2)
      : "?.??"
    : "?.??";

  let color = "#000";

  if (score < 2.5) {
    color = "rgb(53, 25, 109)";
  } else if (score < 3) {
    color = "rgb(122, 51, 255)";
  } else if (score < 3.5) {
    color = "rgb(64, 67, 231)";
  } else if (score < 4.0) {
    color = "rgb(23, 224, 228)";
  } else if (score < 4.2) {
    color = "rgb(33, 218, 73)";
  } else if (score < 4.4) {
    color = "rgb(179, 238, 16)";
  } else {
    color = "rgb(240, 206, 13)";
  }

  if (scoreText === "?.??") {
    color = "rgb(0, 0, 0)";
  }

  return (
    <span style={{ color, fontWeight: 600 }}>
      {scoreText}
    </span>
  );
}
